import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from "@angular/core";

@Directive({
	selector: '[cpAddClassToClosestParent]'
})
export class AddClassToClosestParentDirective implements AfterViewInit{

	@Input() addedClassName: string;
	@Input() parentClassSelector: string;

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngAfterViewInit() {
		const parentMenuPopupElement = this.el.nativeElement.closest(this.parentClassSelector);
		if (parentMenuPopupElement) {
			this.renderer.addClass(parentMenuPopupElement, this.addedClassName);
		}
	}

}
